<div class="page-header p-2">
  <h1>Example page</h1>
  <p class="lead">
    A page for visualizing applied BS styles.
  </p>
  <p>
    As this page has to be displayed inside the angular wrapper component, wich already uses BS containers, some items may not look or function correctly.
  </p>
  <p>
    All content on below is wrapped in a "card like" container for more realistic context, as pretty much all content on the site sits inside a card.
  </p>
  <p>Several Bootstrap sections/elements have been removed, as they are not in use, but this does not mean that all visible items are in use.</p>
</div>

<!-- Navbar
==================================================
Hidden as navbars are not in use

<div class="bs-docs-section clearfix">
  <div class="row">
    <div class="col-lg-12">
      <div class="page-header">
        <h1 id="navbars">Navbars</h1>
      </div>

      <div class="bs-component">
        <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
          <a class="navbar-brand" href="javascript:void(0);">Navbar</a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarColor01">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item active">
                <a class="nav-link" href="javascript:void(0);">Home <span class="sr-only">(current)</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);">Features</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);">About</a>
              </li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
              <input class="form-control mr-sm-2" type="text" placeholder="Search">
              <button class="btn btn-secondary my-2 my-sm-0" type="submit">Search</button>
            </form>
          </div>
        </nav>
      </div>

      <div class="bs-component">
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
          <a class="navbar-brand" href="javascript:void(0);">Navbar</a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor02" aria-controls="navbarColor02" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarColor02">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item active">
                <a class="nav-link" href="javascript:void(0);">Home <span class="sr-only">(current)</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);">Features</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);">About</a>
              </li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
              <input class="form-control mr-sm-2" type="text" placeholder="Search">
              <button class="btn btn-secondary my-2 my-sm-0" type="submit">Search</button>
            </form>
          </div>
        </nav>
      </div>

      <div class="bs-component">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
          <a class="navbar-brand" href="javascript:void(0);">Navbar</a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor03" aria-controls="navbarColor03" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarColor03">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item active">
                <a class="nav-link" href="javascript:void(0);">Home <span class="sr-only">(current)</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);">Features</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="javascript:void(0);">About</a>
              </li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
              <input class="form-control mr-sm-2" type="text" placeholder="Search">
              <button class="btn btn-secondary my-2 my-sm-0" type="submit">Search</button>
            </form>
          </div>
        </nav>
      </div>

    </div>
  </div>
</div>
-->

<div class="bs-docs-section card standalone show">
  <h1 id="colors" class="card-header text-center">Colors</h1>
  <div class="card-body">
    <div class="row">
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
        <div class="p-2">
          <div class="bg-primary border border-light d-inline-block p-4 mr-2 align-middle"></div>
          <strong class="text-primary align-middle">Primary</strong>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
        <div class="p-2">
          <div class="bg-secondary border border-light d-inline-block p-4 mr-2 align-middle"></div>
          <strong class="text-secondary align-middle">Secondary</strong>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
        <div class="p-2">
          <div class="bg-success border border-light d-inline-block p-4 mr-2 align-middle"></div>
          <strong class="text-success align-middle">Success</strong>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
        <div class="p-2">
          <div class="bg-info border border-light d-inline-block p-4 mr-2 align-middle"></div>
          <strong class="text-info align-middle">Info</strong>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
        <div class="p-2">
          <div class="bg-warning border border-light d-inline-block p-4 mr-2 align-middle"></div>
          <strong class="text-warning align-middle">Warning</strong>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
        <div class="p-2">
          <div class="bg-danger border border-light d-inline-block p-4 mr-2 align-middle"></div>
          <strong class="text-danger align-middle">Danger</strong>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
        <div class="p-2" style="background-color: #000;">
          <div class="bg-light border border-dark d-inline-block p-4 mr-2 align-middle"></div>
          <strong class="text-light align-middle">Light <small>(on black)</small></strong>
        </div>
      </div>
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
        <div class="p-2" style="background-color: #FFF;">
          <div class="bg-dark border border-light d-inline-block p-4 mr-2 align-middle"></div>
          <strong class="text-dark align-middle">Dark <small>(on white)</small></strong>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Buttons
================================================== -->

<div class="bs-docs-section card standalone show">
  <h1 id="buttons" class="card-header text-center">Buttons</h1>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-7">

        <p class="bs-component">
          <button type="button" class="btn btn-primary">Primary</button>{{' '}}
          <button type="button" class="btn btn-secondary">Secondary</button>{{' '}}
          <button type="button" class="btn btn-success">Success</button>{{' '}}
          <button type="button" class="btn btn-info">Info</button>{{' '}}
          <button type="button" class="btn btn-warning">Warning</button>{{' '}}
          <button type="button" class="btn btn-danger">Danger</button>{{' '}}
          <button type="button" class="btn btn-link">Link</button>{{' '}}
        </p>

        <p class="bs-component">
          <button type="button" class="btn btn-primary disabled">Primary</button>{{' '}}
          <button type="button" class="btn btn-secondary disabled">Secondary</button>{{' '}}
          <button type="button" class="btn btn-success disabled">Success</button>{{' '}}
          <button type="button" class="btn btn-info disabled">Info</button>{{' '}}
          <button type="button" class="btn btn-warning disabled">Warning</button>{{' '}}
          <button type="button" class="btn btn-danger disabled">Danger</button>{{' '}}
          <button type="button" class="btn btn-link disabled">Link</button>{{' '}}
        </p>

        <p class="bs-component">
          <button type="button" class="btn btn-outline-primary">Primary</button>{{' '}}
          <button type="button" class="btn btn-outline-secondary">Secondary</button>{{' '}}
          <button type="button" class="btn btn-outline-success">Success</button>{{' '}}
          <button type="button" class="btn btn-outline-info">Info</button>{{' '}}
          <button type="button" class="btn btn-outline-warning">Warning</button>{{' '}}
          <button type="button" class="btn btn-outline-danger">Danger</button>{{' '}}
        </p>

        <div class="bs-component">
          <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
            <button type="button" class="btn btn-primary">Primary</button>
            <div class="btn-group dropdown" role="group" ngbDropdown>
              <button id="btnGroupDrop1" type="button" ngbDropdownToggle class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1" ngbDropdownMenu>
                <a class="dropdown-item active" href="javascript:void(0);">Dropdown link</a>
                <a class="dropdown-item" href="javascript:void(0);">Dropdown link</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item disabled" href="javascript:void(0);">Dropdown link</a>
              </div>
            </div>
          </div>{{' '}}

          <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
            <button type="button" class="btn btn-success">Success</button>
            <div class="btn-group" role="group" ngbDropdown>
              <button id="btnGroupDrop2" type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle></button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop2" ngbDropdownMenu>
                <a class="dropdown-item" href="javascript:void(0);">Dropdown link</a>
                <a class="dropdown-item" href="javascript:void(0);">Dropdown link</a>
              </div>
            </div>
          </div>{{' '}}

          <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
            <button type="button" class="btn btn-info">Info</button>
            <div class="btn-group" role="group" ngbDropdown>
              <button id="btnGroupDrop3" type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle></button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop3" ngbDropdownMenu>
                <a class="dropdown-item" ngbDropdownItem href="javascript:void(0);">Dropdown link</a>
                <a class="dropdown-item" ngbDropdownItem href="javascript:void(0);">Dropdown link</a>
              </div>
            </div>
          </div>{{' '}}

          <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
            <button type="button" class="btn btn-danger">Danger</button>
            <div class="btn-group" role="group" ngbDropdown>
              <button id="btnGroupDrop4" type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle></button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop4" ngbDropdownMenu>
                <a class="dropdown-item" href="javascript:void(0);">Dropdown link</a>
                <a class="dropdown-item" href="javascript:void(0);">Dropdown link</a>
              </div>
            </div>
          </div>{{' '}}
        </div>

        <div class="bs-component">
          <button type="button" class="btn btn-primary btn-lg">Large button</button>{{' '}}
          <button type="button" class="btn btn-primary">Default button</button>{{' '}}
          <button type="button" class="btn btn-primary btn-sm">Small button</button>{{' '}}
        </div>

      </div>
      <div class="col-lg-5">

        <p class="bs-component">
          <button type="button" class="btn btn-primary btn-lg btn-block">Block level button</button>
        </p>

        <div class="bs-component">
          <div class="btn-group btn-group-toggle" data-toggle="buttons">
            <label class="btn btn-primary active">
              <input type="checkbox" checked autocomplete="off"> Active
            </label>
            <label class="btn btn-primary">
              <input type="checkbox" autocomplete="off"> Check
            </label>
            <label class="btn btn-primary">
              <input type="checkbox" autocomplete="off"> Check
            </label>
          </div>
        </div>

        <div class="bs-component">
          <div class="btn-group btn-group-toggle" data-toggle="buttons">
            <label class="btn btn-primary active">
              <input type="radio" name="options" id="option1" autocomplete="off" checked> Active
            </label>
            <label class="btn btn-primary">
              <input type="radio" name="options" id="option2" autocomplete="off"> Radio
            </label>
            <label class="btn btn-primary">
              <input type="radio" name="options" id="option3" autocomplete="off"> Radio
            </label>
          </div>
        </div>
        <!--
        hidden as vertical groups are not in use

        <div class="bs-component">
          <div class="btn-group-vertical" data-toggle="buttons">
            <button type="button" class="btn btn-primary">Button</button>
            <button type="button" class="btn btn-primary">Button</button>
            <button type="button" class="btn btn-primary">Button</button>
            <button type="button" class="btn btn-primary">Button</button>
            <button type="button" class="btn btn-primary">Button</button>
            <button type="button" class="btn btn-primary">Button</button>
          </div>
        </div>
        -->
        <div class="bs-component">
          <div class="btn-group" role="group" aria-label="Basic example">
            <button type="button" class="btn btn-secondary">Left</button>
            <button type="button" class="btn btn-secondary">Middle</button>
            <button type="button" class="btn btn-secondary">Right</button>
          </div>
        </div>

        <div class="bs-component">
          <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
            <div class="btn-group mr-2" role="group" aria-label="First group">
              <button type="button" class="btn btn-secondary">1</button>
              <button type="button" class="btn btn-secondary">2</button>
              <button type="button" class="btn btn-secondary">3</button>
              <button type="button" class="btn btn-secondary">4</button>
            </div>
            <div class="btn-group mr-2" role="group" aria-label="Second group">
              <button type="button" class="btn btn-secondary">5</button>
              <button type="button" class="btn btn-secondary">6</button>
              <button type="button" class="btn btn-secondary">7</button>
            </div>
            <div class="btn-group" role="group" aria-label="Third group">
              <button type="button" class="btn btn-secondary">8</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Typography
================================================== -->
<div class="bs-docs-section card standalone show">
  <h1 id="typography" class="card-header text-center">Typography</h1>
  <!-- Headings -->
  <div class="card-body">
    <div class="row">
      <div class="col-lg-4">
        <div class="bs-component">
          <h1>Heading 1</h1>
          <h2>Heading 2</h2>
          <h3>Heading 3</h3>
          <h4>Heading 4</h4>
          <h5>Heading 5</h5>
          <h6>Heading 6</h6>
          <h3>
            Heading
            <small class="text-muted">with muted text</small>
          </h3>
          <p class="lead">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <h2>Example body text</h2>
          <p>Nullam quis risus eget <a href="javascript:void(0);">urna mollis ornare</a> vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula.</p>
          <p><small>This line of text is meant to be treated as fine print.</small></p>
          <p>The following is <strong>rendered as bold text</strong>.</p>
          <p>The following is <em>rendered as italicized text</em>.</p>
          <p>An abbreviation of the word attribute is <abbr title="attribute">attr</abbr>.</p>
        </div>

      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <h2>Emphasis classes</h2>
          <p class="text-muted"><strong>Muted:</strong> Fusce dapibus, tellus ac cursus commodo, tortor mauris nibh.</p>
          <p class="text-primary"><strong>Primary:</strong> PrimNullam id dolor id nibh ultricies vehicula ut id elit.</p>
          <p class="text-secondary"><strong>Secondary:</strong> Pellentesque ornare sem lacinia quam venenatis vestibulum.</p>
          <p class="text-warning"><strong>Warning:</strong> Etiam porta sem malesuada magna mollis euismod.</p>
          <p class="text-danger"><strong>Danger: </strong> Donec ullamcorper nulla non metus auctor fringilla.</p>
          <p class="text-success"><strong>Success: </strong> Duis mollis, est non commodo luctus, nisi erat porttitor ligula.</p>
          <p class="text-info"><strong>Info: </strong> Maecenas sed diam eget risus varius blandit sit amet non magna.</p>
        </div>

      </div>
    </div>

    <!-- Blockquotes
    Hidden as blockquotes are not in use

    <div class="row">
      <div class="col-lg-12">
        <h2 id="type-blockquotes">Blockquotes</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <div class="bs-component">
          <blockquote class="blockquote">
            <p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
            <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
          </blockquote>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <blockquote class="blockquote text-center">
            <p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
            <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
          </blockquote>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <blockquote class="blockquote text-right">
            <p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
            <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
          </blockquote>
        </div>
      </div>
    </div>
    -->
  </div>
</div>

<!-- Tables
==================================================
Hidden as tables are not in use
<div class="bs-docs-section">

  <div class="row">
    <div class="col-lg-12">
      <div class="page-header">
        <h1 id="tables">Tables</h1>
      </div>

      <div class="bs-component">
        <table class="table table-hover">
          <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Column heading</th>
            <th scope="col">Column heading</th>
            <th scope="col">Column heading</th>
          </tr>
          </thead>
          <tbody>
          <tr class="table-active">
            <th scope="row">Active</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          <tr>
            <th scope="row">Default</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          <tr class="table-primary">
            <th scope="row">Primary</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          <tr class="table-secondary">
            <th scope="row">Secondary</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          <tr class="table-success">
            <th scope="row">Success</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          <tr class="table-danger">
            <th scope="row">Danger</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          <tr class="table-warning">
            <th scope="row">Warning</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          <tr class="table-info">
            <th scope="row">Info</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          <tr class="table-light">
            <th scope="row">Light</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          <tr class="table-dark">
            <th scope="row">Dark</th>
            <td>Column content</td>
            <td>Column content</td>
            <td>Column content</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
-->

<!-- Forms
================================================== -->
<div class="bs-docs-section card standalone show">
  <h1 id="forms" class="card-header text-center">Forms</h1>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <div class="bs-component">
          <form>
            <fieldset>
              <legend>Legend</legend>
              <!--
              <div class="form-group row">
                <label for="staticEmail" class="col-sm-2 col-form-label">Email</label>
                <div class="col-sm-10">
                  <input type="text" readonly class="form-control-plaintext" id="staticEmail" value="email@example.com">
                </div>
              </div>
              -->
              <!--
              <div class="form-group">
                <label for="exampleInputFile">File input</label>
                <input type="file" class="form-control-file" id="exampleInputFile" aria-describedby="fileHelp">
                <small id="fileHelp" class="form-text text-muted">This is some placeholder block-level help text for the above input. It's a bit lighter and easily wraps to a new line.</small>
              </div>
              <fieldset class="form-group">
                <legend>Radio buttons</legend>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optionsRadios" id="optionsRadios1" value="option1" checked>
                    Option one is this and that&mdash;be sure to include why it's great
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optionsRadios" id="optionsRadios2" value="option2">
                    Option two can be something else and selecting it will deselect option one
                  </label>
                </div>
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="optionsRadios" id="optionsRadios3" value="option3" disabled>
                    Option three is disabled
                  </label>
                </div>
              </fieldset>
              <fieldset class="form-group">
                <legend>Checkboxes</legend>
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" value="" checked>
                    Option one is this and that&mdash;be sure to include why it's great
                  </label>
                </div>
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" value="" disabled>
                    Option two is disabled
                  </label>
                </div>
              </fieldset>
              <fieldset class="form-group">
                <legend>Sliders</legend>
                <label for="customRange1">Example range</label>
                <input type="range" class="custom-range" id="customRange1">
              </fieldset>
              <button type="submit" class="btn btn-primary">Submit</button>
              -->
              <!--
              <div class="form-group">
                <label for="exampleSelect2">Example multiple select</label>
                <select multiple class="form-control" id="exampleSelect2">
                  <option>Please select a value</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>
              </div>
              -->
              <div class="form-group">
                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                <small id="emailHelp" class="feedback info-feedback small form-text text-muted text-right">
                  <span class="icon mr-1 fa fa-fw fa-info-circle"></span>We'll never share your email with anyone else.</small>
                <label class="placeholder-label" for="exampleInputEmail1">Email address</label>
              </div>
              <div class="form-group">
                <input type="password" class="form-control" id="exampleInputPassword1" />
                <label class="placeholder-label" for="exampleInputPassword1">Password</label>
              </div>
              <div class="form-group">
                <select class="form-control with-placeholder-label" id="exampleSelect1">
                  <option>Please select a value</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </select>
                <label class="placeholder-label" for="exampleSelect1">Example select</label>
              </div>
              <div class="form-group">
                <textarea class="form-control" id="exampleTextarea" rows="3"></textarea>
                <label class="placeholder-label" for="exampleTextarea">Example textarea</label>
              </div>
              <div class="form-group">
                <fieldset disabled>
                  <input class="form-control" id="disabledInput" type="text" disabled="" />
                  <label class="placeholder-label" for="disabledInput">Disabled input</label>
                </fieldset>
              </div>
              <div class="form-group">
                <fieldset>
                  <input class="form-control" id="readOnlyInput" type="text" readonly />
                  <label class="placeholder-label" for="readOnlyInput">Readonly input</label>
                </fieldset>
              </div>
              <div class="form-group has-success">
                <input type="text" class="form-control is-valid" id="inputValid" />
                <label class="placeholder-label" for="inputValid">Valid input</label>
                <div class="feedback valid-feedback text-right">
                  <span class="icon mr-1 fa fa-fw fa-check-circle"></span>Success! You've done it.
                </div>
              </div>
              <div class="form-group has-danger">
                <input type="text" class="form-control is-invalid" id="inputInvalid">
                <label class="placeholder-label" for="inputInvalid">Invalid input</label>
                <div class="feedback invalid-feedback text-right">
                  <span class="icon mr-1 fa fa-fw fa-exclamation-circle"></span>Sorry, that username's taken. Try another?
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      <div class="col-lg-6">
        <form class="bs-component">
          <fieldset>
            <legend>With values</legend>
            <div class="form-group">
              <input type="email" class="form-control has-value" value="foo@bar.com" id="exampleInputEmail1val" aria-describedby="emailHelp" />
              <small id="emailHelpVal" class="feedback info-feedback small form-text text-muted text-right">
                <span class="icon mr-1 fa fa-fw fa-info-circle"></span>We'll never share your email with anyone else.</small>
              <label class="placeholder-label" for="exampleInputEmail1Val">Email address</label>
            </div>
            <div class="form-group">
              <input type="password" class="form-control has-value" id="exampleInputPassword1Val" value="123456"/>
              <label class="placeholder-label" for="exampleInputPassword1Val">Password</label>
            </div>
            <div class="form-group">
              <select class="form-control with-placeholder-label has-value" id="exampleSelect1Val">
                <option>Please select a value</option>
                <option>1</option>
                <option selected>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
              <label class="placeholder-label" for="exampleSelect1Val">Example select</label>
            </div>
            <div class="form-group">
              <textarea class="form-control has-value" id="exampleTextareaVal" rows="3">Lorem ipsum dolor sit amet</textarea>
              <label class="placeholder-label" for="exampleTextareaVal">Example textarea</label>
            </div>
            <div class="form-group">
              <fieldset disabled>
                <input class="form-control has-value" id="disabledInputVal" type="text" disabled value="Disabled" />
                <label class="placeholder-label" for="disabledInputVal">Disabled input</label>
              </fieldset>
            </div>
            <div class="form-group">
              <fieldset>
                <input class="form-control has-value" id="readOnlyInputVal" type="text" readonly value="Readonly"/>
                <label class="placeholder-label" for="readOnlyInputVal">Readonly input</label>
              </fieldset>
            </div>
            <div class="form-group has-success">
              <input type="text" class="form-control is-valid has-value" id="inputValidVal" value="Valid"/>
              <label class="placeholder-label" for="inputValidVal">Valid input</label>
              <div class="feedback valid-feedback text-right">
                <span class="icon mr-1 fa fa-fw fa-check-circle"></span>Success! You've done it.
              </div>
            </div>
            <div class="form-group has-danger">
              <input type="text" class="form-control is-invalid has-value" id="inputInvalidVal" value="Invalid"/>
              <label class="placeholder-label" for="inputInvalidVal">Invalid input</label>
              <div class="feedback invalid-feedback text-right">
                <span class="icon mr-1 fa fa-fw fa-exclamation-circle"></span>Sorry, that username's taken. Try another?
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
    <form class="bs-component mt-3">
      <fieldset>
        <legend>Input size variants</legend>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group">
              <input class="form-control form-control-lg has-value" type="text" value=".form-control-lg" id="inputLarge" />
              <label class="placeholder-label" for="inputLarge">Large input</label>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <input type="text" class="form-control has-value" value="Default input" id="inputDefault" />
              <label class="placeholder-label" for="inputDefault">Default input</label>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <input class="form-control form-control-sm has-value" type="text" value=".form-control-sm" id="inputSmall" />
              <label class="placeholder-label" for="inputSmall">Small input</label>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Input Addons</legend>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group">
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <div class="flex-shrink-1 flex-grow-1 position-relative">
                    <input type="text" class="form-control" aria-label="Amount (to the nearest dollar)" />
                    <label class="placeholder-label on-top">Input addons</label>
                  </div>
                  <div class="input-group-append">
                    <span class="input-group-text">.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="icon input-group-text bg-danger border-danger text-white"><span class="fa fa-fw fa-ban"></span></span>
                  </div>
                  <div class="flex-shrink-1 flex-grow-1 position-relative">
                    <input type="text" class="form-control" value="Not" readonly />
                    <label class="placeholder-label on-top">Readonly with state and btn</label>
                  </div>
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button">Change</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="icon input-group-text bg-success border-success text-white"><span class="fa fa-fw fa-check"></span></span>
                  </div>
                  <div class="flex-shrink-1 flex-grow-1 position-relative">
                    <input type="text" class="form-control" value="Yes" readonly />
                    <label class="placeholder-label on-top">Readonly with state and btn</label>
                  </div>
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button">Change</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Custom forms</legend>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group">
              <div class="custom-control custom-radio">
                <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input" checked>
                <label class="custom-control-label" for="customRadio1">Toggle this custom radio</label>
              </div>
              <div class="custom-control custom-radio">
                <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input">
                <label class="custom-control-label" for="customRadio2">Or toggle this other custom radio</label>
              </div>
              <div class="custom-control custom-radio">
                <input type="radio" id="customRadio3" name="customRadio" class="custom-control-input" disabled>
                <label class="custom-control-label" for="customRadio3">Disabled custom radio</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheck1" checked>
                <label class="custom-control-label" for="customCheck1">Check this custom checkbox</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheck2" disabled>
                <label class="custom-control-label" for="customCheck2">Disabled custom checkbox</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input has-value is-invalid" id="customCheck1Invalid">
                <label class="custom-control-label" for="customCheck1Invalid">Check <a href="javascript:void(0);">this</a></label>
                <div class="feedback invalid-feedback text-right">
                  <span class="icon mr-1 fa fa-fw fa-exclamation-circle"></span>Check me!
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input has-value is-valid" id="customCheck1Valid">
                <label class="custom-control-label" for="customCheck1Valid">Check <a href="javascript:void(0);">this</a></label>
              </div>
            </div>

          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="customSwitch1" checked>
                <label class="custom-control-label" for="customSwitch1">Toggle this switch element</label>
              </div>
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" disabled id="customSwitch2">
                <label class="custom-control-label" for="customSwitch2">Disabled switch element</label>
              </div>
            </div>
          </div>
          <!--
            <div class="form-group">
              <select class="custom-select">
                <option selected>Open this select menu</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>
            -->
        </div>
        <hr />
        <div class="row">
          <div class="col-lg-6 offset-lg-3">
            <div class="form-group">
              <div class="input-group mb-3">
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="inputGroupFile02">
                  <label class="custom-file-label" for="inputGroupFile02">Choose file</label>
                </div>
                <div class="input-group-append">
                  <span class="input-group-text" id="">Upload</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</div>

<!-- Navs
================================================== -->
<div class="bs-docs-section card standalone show">
  <h1 id="navs" class="card-header text-center">Navs</h1>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <h2 id="nav-tabs">Tabs</h2>
        <div class="bs-component">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="tab" href="javascript:void(0);">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="javascript:void(0);">Profile</a>
            </li>
            <li class="nav-item">
              <a class="nav-link disabled" href="javascript:void(0);">Disabled</a>
            </li>
            <li class="nav-item dropdown" ngbDropdown>
              <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="javascript:void(0);" role="button" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>Dropdown</a>
              <div class="dropdown-menu" ngbDropdownMenu>
                <a class="dropdown-item" href="javascript:void(0);">Action</a>
                <a class="dropdown-item" href="javascript:void(0);">Another action</a>
                <a class="dropdown-item" href="javascript:void(0);">Something else here</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="javascript:void(0);">Separated link</a>
              </div>
            </li>
          </ul>
          <div id="myTabContent" class="tab-content">
            <div class="tab-pane fade show active" id="home">
              <p>Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <h2 id="nav-pills">Pills</h2>
        <div class="bs-component">
          <ul class="nav nav-pills">
            <li class="nav-item">
              <a class="nav-link active" href="javascript:void(0);">Active</a>
            </li>
            <li class="nav-item dropdown" ngbDropdown>
              <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="javascript:void(0);" role="button" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>Dropdown</a>
              <div class="dropdown-menu" ngbDropdownMenu>
                <a class="dropdown-item" href="javascript:void(0);">Action</a>
                <a class="dropdown-item" href="javascript:void(0);">Another action</a>
                <a class="dropdown-item" href="javascript:void(0);">Something else here</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="javascript:void(0);">Separated link</a>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0);">Link</a>
            </li>
            <li class="nav-item">
              <a class="nav-link disabled" href="javascript:void(0);">Disabled</a>
            </li>
          </ul>
        </div>
        <br>
        <div class="bs-component">
          <ul class="nav nav-pills flex-column">
            <li class="nav-item">
              <a class="nav-link active" href="javascript:void(0);">Active</a>
            </li>
            <li class="nav-item dropdown" ngbDropdown>
              <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="javascript:void(0);" role="button" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>Dropdown</a>
              <div class="dropdown-menu" ngbDropdownMenu="">
                <a class="dropdown-item" href="javascript:void(0);">Action</a>
                <a class="dropdown-item" href="javascript:void(0);">Another action</a>
                <a class="dropdown-item" href="javascript:void(0);">Something else here</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="javascript:void(0);">Separated link</a>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0);">Link</a>
            </li>
            <li class="nav-item">
              <a class="nav-link disabled" href="javascript:void(0);">Disabled</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- hidden as breadcrumbs or pagination is not in use
    <div class="row">
      <div class="col-lg-6">
        <h2 id="nav-breadcrumbs">Breadcrumbs</h2>
        <div class="bs-component">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">Home</li>
          </ol>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0);">Home</a></li>
            <li class="breadcrumb-item active">Library</li>
          </ol>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="javascript:void(0);">Home</a></li>
            <li class="breadcrumb-item"><a href="javascript:void(0);">Library</a></li>
            <li class="breadcrumb-item active">Data</li>
          </ol>
        </div>
      </div>

      <div class="col-lg-6">
        <h2 id="pagination">Pagination</h2>
        <div class="bs-component">
          <div>
            <ul class="pagination">
              <li class="page-item disabled">
                <a class="page-link" href="javascript:void(0);">&laquo;</a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript:void(0);">1</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">2</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">3</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">4</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">5</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">&raquo;</a>
              </li>
            </ul>
          </div>

          <div>
            <ul class="pagination pagination-lg">
              <li class="page-item disabled">
                <a class="page-link" href="javascript:void(0);">&laquo;</a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript:void(0);">1</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">2</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">3</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">4</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">5</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">&raquo;</a>
              </li>
            </ul>
          </div>

          <div>
            <ul class="pagination pagination-sm">
              <li class="page-item disabled">
                <a class="page-link" href="javascript:void(0);">&laquo;</a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript:void(0);">1</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">2</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">3</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">4</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">5</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript:void(0);">&raquo;</a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
    -->
  </div>
</div>

<!-- Indicators
================================================== -->
<div class="bs-docs-section card standalone show">
  <h1 id="indicators" class="card-header text-center">Indicators</h1>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-12">
        <h2>Alerts</h2>
      </div>
    </div>
    <div class="row">
      <!--
        hidden as not in use
          <div class="bs-component">
            <div class="alert alert-dismissible alert-warning static">
              <button type="button" class="close" data-dismiss="alert">&times;</button>
              <h4 class="alert-heading">Warning!</h4>
              <p class="mb-0">Best check yo self, you're not looking too good. Nulla vitae elit libero, a pharetra augue. Praesent commodo cursus magna, <a href="javascript:void(0);" class="alert-link">vel scelerisque nisl consectetur et</a>.</p>
            </div>
          </div>
        -->
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="alert alert-dismissible alert-danger static d-flex align-items-stretch flex-column flex-sm-row">
            <button type="button" class="close" data-dismiss="alert">&times;</button>
            <span
            class="icon fa fa-fw flex-shrink-0 fa-2x align-middle d-flex fa-exclamation-triangle"
          ></span>
            <div class="align-middle">
              <strong>Oh snap!</strong>{{' '}}<a href="javascript:void(0);" class="alert-link">Change a few things up</a> and try submitting again.
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="alert alert-dismissible alert-success static d-flex align-items-stretch flex-column flex-sm-row">
            <button type="button" class="close" data-dismiss="alert">&times;</button>
            <span
            class="icon fa fa-fw flex-shrink-0 fa-2x align-middle d-flex fa-check-circle align-items-center"
          ></span>
            <div class="align-middle">
              <strong>Well done!</strong> You successfully read <a href="javascript:void(0);" class="alert-link">this important alert message</a>.
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="alert alert-info static d-flex align-items-stretch flex-column flex-sm-row">
            <span
              class="icon fa fa-fw flex-shrink-0 fa-2x align-middle d-flex fa-info-circle"
            ></span>
            <div class="align-middle">
              <strong>Heads up!</strong> This <a href="javascript:void(0);" class="alert-link">alert needs your attention</a>, but it's not super important.
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--
    hidden as not in use
    <div class="row">
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="alert alert-dismissible alert-primary static">
            <button type="button" class="close" data-dismiss="alert">&times;</button>
            <strong>Oh snap!</strong> <a href="javascript:void(0);" class="alert-link">Change a few things up</a> and try submitting again.
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="alert alert-dismissible alert-secondary static">
            <button type="button" class="close" data-dismiss="alert">&times;</button>
            <strong>Well done!</strong> You successfully read <a href="javascript:void(0);" class="alert-link">this important alert message</a>.
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="alert alert-dismissible alert-light static">
            <button type="button" class="close" data-dismiss="alert">&times;</button>
            <strong>Heads up!</strong> This <a href="javascript:void(0);" class="alert-link">alert needs your attention</a>, but it's not super important.
          </div>
        </div>
      </div>
    </div>
      -->
    <div>
      <h2>Badges</h2>
      <div class="bs-component">
        <span class="badge badge-primary">Primary</span>{{' '}}
        <span class="badge badge-secondary">Secondary</span>{{' '}}
        <span class="badge badge-success">Success</span>{{' '}}
        <span class="badge badge-danger">Danger</span>{{' '}}
        <span class="badge badge-warning">Warning</span>{{' '}}
        <span class="badge badge-info">Info</span>{{' '}}
        <span class="badge badge-light">Light</span>{{' '}}
        <span class="badge badge-dark">Dark</span>{{' '}}
      </div>
      <div class="bs-component">
        <span class="badge badge-pill badge-primary">Primary</span>{{' '}}
        <span class="badge badge-pill badge-secondary">Secondary</span>{{' '}}
        <span class="badge badge-pill badge-success">Success</span>{{' '}}
        <span class="badge badge-pill badge-danger">Danger</span>{{' '}}
        <span class="badge badge-pill badge-warning">Warning</span>{{' '}}
        <span class="badge badge-pill badge-info">Info</span>{{' '}}
        <span class="badge badge-pill badge-light">Light</span>{{' '}}
        <span class="badge badge-pill badge-dark">Dark</span>{{' '}}
      </div>
    </div>
  </div>
</div>

<!-- Progress
==================================================
hidden as progress indicators are not in use
<div class="bs-docs-section">

<div class="row">
  <div class="col-lg-12">
    <div class="page-header">
      <h1 id="progress">Progress</h1>
    </div>

    <h3 id="progress-basic">Basic</h3>
    <div class="bs-component">
      <div class="progress">
        <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>

    <h3 id="progress-alternatives">Contextual alternatives</h3>
    <div class="bs-component">
      <div class="progress">
        <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div class="progress">
        <div class="progress-bar bg-info" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div class="progress">
        <div class="progress-bar bg-warning" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div class="progress">
        <div class="progress-bar bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>

    <h3 id="progress-multiple">Multiple bars</h3>
    <div class="bs-component">
      <div class="progress">
        <div class="progress-bar" role="progressbar" style="width: 15%" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
        <div class="progress-bar bg-success" role="progressbar" style="width: 30%" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
        <div class="progress-bar bg-info" role="progressbar" style="width: 20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>

    <h3 id="progress-striped">Striped</h3>
    <div class="bs-component">
      <div class="progress">
        <div class="progress-bar progress-bar-striped" role="progressbar" style="width: 10%" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div class="progress">
        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div class="progress">
        <div class="progress-bar progress-bar-striped bg-info" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div class="progress">
        <div class="progress-bar progress-bar-striped bg-warning" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div class="progress">
        <div class="progress-bar progress-bar-striped bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>

    <h3 id="progress-animated">Animated</h3>
    <div class="bs-component">
      <div class="progress">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 75%"></div>
      </div>
    </div>
  </div>
</div>
</div>
-->

<!-- Containers
================================================== -->
<div class="bs-docs-section card standalone show">
  <h1 id="containers" class="card-header text-center">Containers</h1>
      <!-- Hidden as jumbotrons are not in use
      <div class="bs-component">
        <div class="jumbotron">
          <h1 class="display-3">Hello, world!</h1>
          <p class="lead">This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.</p>
          <hr class="my-4">
          <p>It uses utility classes for typography and spacing to space content out within the larger container.</p>
          <p class="lead">
            <a class="btn btn-primary btn-lg" href="javascript:void(0);" role="button">Learn more</a>
          </p>
        </div>
      </div>
      -->
  <div class="card-body">
    <div class="row">
      <div class="col-lg-12">
        <h2>List groups</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="bs-component">
          <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Cras justo odio
              <span class="badge badge-primary badge-pill">14</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Dapibus ac facilisis in
              <span class="badge badge-primary badge-pill">2</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Morbi leo risus
              <span class="badge badge-primary badge-pill">1</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="list-group">
            <a href="javascript:void(0);" class="list-group-item list-group-item-action active">
              Cras justo odio
            </a>
            <a href="javascript:void(0);" class="list-group-item list-group-item-action">Dapibus ac facilisis in
            </a>
            <a href="javascript:void(0);" class="list-group-item list-group-item-action disabled">Morbi leo risus
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="list-group">
            <a href="javascript:void(0);" class="list-group-item list-group-item-action flex-column align-items-start active">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">List group item heading</h5>
                <small>3 days ago</small>
              </div>
              <p class="mb-1">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p>
              <small>Donec id elit non mi porta.</small>
            </a>
            <a href="javascript:void(0);" class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">List group item heading</h5>
                <small class="text-muted">3 days ago</small>
              </div>
              <p class="mb-1">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p>
              <small class="text-muted">Donec id elit non mi porta.</small>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <h2>Cards</h2>
      </div>
    </div>

      <!--
      Hidden as not in use
    <div class="row">
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="card text-white bg-primary mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Primary card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card text-white bg-secondary mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Secondary card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card text-white bg-success mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Success card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card text-white bg-danger mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Danger card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card text-white bg-warning mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Warning card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card text-white bg-info mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Info card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card bg-light mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Light card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card text-white bg-dark mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Dark card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="card border-primary mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Primary card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card border-secondary mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Secondary card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card border-success mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Success card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card border-danger mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Danger card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card border-warning mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Warning card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card border-info mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Info card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card border-light mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Light card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
          <div class="card border-dark mb-3" style="max-width: 20rem;">
            <div class="card-header text-center">Header</div>
            <div class="card-body">
              <h4 class="card-title">Dark card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="bs-component">
          <div class="card mb-3">
            <h3 class="card-header text-center">Card header</h3>
            <div class="card-body">
              <h5 class="card-title">Special title treatment</h5>
              <h6 class="card-subtitle text-muted">Support card subtitle</h6>
            </div>
            <img style="height: 200px; width: 100%; display: block;" src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22318%22%20height%3D%22180%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20318%20180%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_158bd1d28ef%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A16pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_158bd1d28ef%22%3E%3Crect%20width%3D%22318%22%20height%3D%22180%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22129.359375%22%20y%3D%2297.35%22%3EImage%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E" alt="Card image">
            <div class="card-body">
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Cras justo odio</li>
              <li class="list-group-item">Dapibus ac facilisis in</li>
              <li class="list-group-item">Vestibulum at eros</li>
            </ul>
            <div class="card-body">
              <a href="javascript:void(0);" class="card-link">Card link</a>
              <a href="javascript:void(0);" class="card-link">Another link</a>
            </div>
            <div class="card-footer text-muted">
              2 days ago
            </div>
          </div>
        </div>
      </div>
          -->
      <div class="bs-component">
        <div class="card-deck">
          <div class="card mr-sm-1">
            <div class="card-header text-center">
              <h4>
                <span class="d-block mx-auto mb-2 icon highlight fa fa-2x fa-fw fa-user"></span>
                Card title
              </h4>
            </div>
            <div class="card-body py-0 small">
              <ul class="list-unstyled">
                <li class="d-flex flex-row align-items-start mb-1">
                  <div class="icon mr-2 flex-shrink-0"><span class="fa fa-fw fa-user"></span></div>
                  <div><strong>Foo</strong>{{' '}}<strong>Bar</strong></div>
                </li>
                <li class="d-flex flex-row align-items-start mb-1">
                  <div class="icon mr-2 flex-shrink-0"><span class="fa fa-fw fa-shield-alt"></span></div>
                  <div><strong>some</strong>{{' '}}<strong>stuff</strong></div>
                </li>
              </ul>
            </div>
            <div class="card-footer text-right pt-0"><span class="visual-link"><span class="icon fa fa-fw fa-pencil-alt"></span> Edit </span></div>
          </div>
          <div class="card mx-sm-1">
            <div class="card-header text-center">
              <h4>
                <span class="d-block mx-auto mb-2 icon highlight fa fa-2x fa-fw fa-address-book"></span>
                Card title
              </h4>
            </div>
            <div class="card-body py-0 small">
              <ul class="list-unstyled">
                <li class="d-flex flex-row align-items-start mb-1">
                  <div class="icon mr-2 flex-shrink-0"><span class="fa fa-fw fa-user"></span></div>
                  <div><strong>Foo</strong>{{' '}}<strong>Bar</strong></div>
                </li>
                <li class="d-flex flex-row align-items-start mb-1">
                  <div class="icon mr-2 flex-shrink-0"><span class="fa fa-fw fa-shield-alt"></span></div>
                  <div><strong>some</strong>{{' '}}<strong>stuff</strong></div>
                </li>
              </ul>
            </div>
            <div class="card-footer text-right pt-0"><span class="visual-link"><span class="icon fa fa-fw fa-pencil-alt"></span> Edit </span></div>
          </div>
          <div class="card ml-sm-1">
            <div class="card-header text-center">
              <h4>
                <span class="d-block mx-auto mb-2 icon highlight fa fa-2x fa-fw fa-user-lock"></span>
                Card title
              </h4>
            </div>
            <div class="card-body py-0 small">
              <ul class="list-unstyled">
                <li class="d-flex flex-row align-items-start mb-1">
                  <div class="icon mr-2 flex-shrink-0"><span class="fa fa-fw fa-user"></span></div>
                  <div><strong>Foo</strong>{{' '}}<strong>Bar</strong></div>
                </li>
                <li class="d-flex flex-row align-items-start mb-1">
                  <div class="icon mr-2 flex-shrink-0"><span class="fa fa-fw fa-shield-alt"></span></div>
                  <div><strong>some</strong>{{' '}}<strong>stuff</strong></div>
                </li>
              </ul>
            </div>
            <div class="card-footer text-right pt-0"><span class="visual-link"><span class="icon fa fa-fw fa-pencil-alt"></span> Edit </span></div>
          </div>
        </div>
    </div>
  </div>

</div>

<!-- Dialogs
================================================== -->
<div class="bs-docs-section card standalone show">
  <h1 id="dialogs" class="card-header text-center">Dialogs</h1>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <h2>Modals</h2>
        <div class="bs-component">
          <div class="modal">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Modal title</h4>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <p>Modal body text goes here.</p>
                </div>
                <div class="modal-footer flex-row-reverse">
                  <button type="button" class="btn btn-success">Save changes</button>
                  <button type="button" class="btn btn-secondary mr-auto" data-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <h2>Popovers</h2>
        <div class="bs-component">
          <button type="button" class="btn btn-secondary" popoverTitle="Popover Title" placement="left" ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">Left</button>{{' '}}

          <button type="button" class="btn btn-secondary" popoverTitle="Popover Title" placement="top" ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">Top</button>{{' '}}

          <button type="button" class="btn btn-secondary" popoverTitle="Popover Title" placement="bottom" ngbPopover="Vivamus
                sagittis lacus vel augue laoreet rutrum faucibus.">Bottom</button>{{' '}}

          <button type="button" class="btn btn-secondary" popoverTitle="Popover Title" placement="right" ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">Right</button>{{' '}}
        </div>
        <h2>Tooltips</h2>
        <div class="bs-component">
          <button type="button" class="btn btn-secondary" placement="left" ngbTooltip="Tooltip on left">Left</button>{{' '}}

          <button type="button" class="btn btn-secondary" placement="top" ngbTooltip="Tooltip on top">Top</button>{{' '}}

          <button type="button" class="btn btn-secondary" placement="bottom" ngbTooltip="Tooltip on bottom">Bottom</button>{{' '}}

          <button type="button" class="btn btn-secondary" placement="right" ngbTooltip="Tooltip on right">Right</button>{{' '}}
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Examples
================================================== -->
<div class="bs-docs-section card standalone show">
  <h1 id="examples" class="card-header text-center">Examples</h1>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h2>Profile picture</h2>
        <div id="profilePicExample" class="float-left mr-2">
          <span class="profile-picture mb-2">X</span>
        </div>
        <p>
          The profile picture consists of a resolved first initial and a background image/color.
        </p>
      </div>
    </div>
  </div>
</div>

<footer id="footer" class="p-2">
      <p>Based on <a href="https://bootswatch.com/default/">https://bootswatch.com/default/</a> by <a href="https://thomaspark.co">Thomas Park</a>, original work released under the <a href="https://github.com/thomaspark/bootswatch/blob/master/LICENSE">MIT License</a>. CSS framework from <a href="https://getbootstrap.com" rel="nofollow">Bootstrap</a>. Icons from <a href="https://fontawesome.com/" rel="nofollow">Font Awesome</a>. Web fonts from <a href="https://fonts.google.com/" rel="nofollow">Google</a>.</p>

</footer>
